exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#stats[data-v-06096c2c] {\n  margin-bottom: 4rem;\n}\n#stats [class*=col-][data-v-06096c2c] {\n  padding: 10px;\n}", ""]);

// exports
